var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15538_22630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15538_22630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17.402V14.7941C1.5 14.2663 1.63583 13.7812 1.90748 13.3388C2.17913 12.8964 2.54003 12.5588 2.9902 12.326C3.95261 11.8448 4.93056 11.4839 5.92402 11.2433C6.91748 11.0027 7.92647 10.8824 8.95098 10.8824C9.52533 10.8824 10.0919 10.9173 10.6507 10.9871C11.2096 11.057 11.7684 11.1695 12.3272 11.3248L10.7672 12.9081C10.4567 12.8615 10.154 12.8227 9.85907 12.7917C9.56413 12.7606 9.26144 12.7451 8.95098 12.7451C8.0817 12.7451 7.22018 12.8499 6.36642 13.0594C5.51266 13.269 4.66667 13.5833 3.82843 14.0025C3.68873 14.0801 3.57618 14.1887 3.49081 14.3284C3.40543 14.4681 3.36275 14.6234 3.36275 14.7941V15.5392H8.95098V17.402H1.5ZM10.8137 18.3333V15.4694L15.9596 10.3468C16.0993 10.2071 16.2545 10.1062 16.4252 10.0441C16.596 9.98203 16.7667 9.95098 16.9375 9.95098C17.1238 9.95098 17.3023 9.98591 17.473 10.0558C17.6438 10.1256 17.799 10.2304 17.9387 10.3701L18.8002 11.2316C18.9244 11.3713 19.0214 11.5266 19.0913 11.6973C19.1612 11.8681 19.1961 12.0388 19.1961 12.2096C19.1961 12.3803 19.165 12.5549 19.1029 12.7335C19.0408 12.912 18.94 13.0711 18.8002 13.2108L13.6777 18.3333H10.8137ZM12.2108 16.9363H13.0956L15.913 14.0956L15.4939 13.6532L15.0515 13.2341L12.2108 16.0515V16.9363ZM15.4939 13.6532L15.0515 13.2341L15.913 14.0956L15.4939 13.6532ZM8.95098 9.95098C7.92647 9.95098 7.04943 9.58619 6.31985 8.85662C5.59028 8.12704 5.22549 7.25 5.22549 6.22549C5.22549 5.20098 5.59028 4.32394 6.31985 3.59436C7.04943 2.86479 7.92647 2.5 8.95098 2.5C9.97549 2.5 10.8525 2.86479 11.5821 3.59436C12.3117 4.32394 12.6765 5.20098 12.6765 6.22549C12.6765 7.25 12.3117 8.12704 11.5821 8.85662C10.8525 9.58619 9.97549 9.95098 8.95098 9.95098ZM8.95098 8.08824C9.46324 8.08824 9.90176 7.90584 10.2665 7.54105C10.6313 7.17627 10.8137 6.73775 10.8137 6.22549C10.8137 5.71324 10.6313 5.27471 10.2665 4.90993C9.90176 4.54514 9.46324 4.36275 8.95098 4.36275C8.43873 4.36275 8.0002 4.54514 7.63542 4.90993C7.27063 5.27471 7.08824 5.71324 7.08824 6.22549C7.08824 6.73775 7.27063 7.17627 7.63542 7.54105C8.0002 7.90584 8.43873 8.08824 8.95098 8.08824Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonEdit);
export default __webpack_public_path__ + "static/media/ic-person-edit.5fd59987f548b17b679811ca91dbaca6.svg";
export { ForwardRef as ReactComponent };